module.exports = __webpack_public_path__ + "static/media/arrow-right.8ba429c6.svg";